/* import Player from '@vimeo/player';
 */

$(document).ready(function () {
    $('.scroll_to_review').on('click', function (evt) {
        evt.preventDefault();
        $('html, body').animate({ scrollTop: $('#looxReviews').offset().top }, 300);
        return false;
    });

    // gallery-thumbs
    let productCarouselThumbsItemWith = $('.gallery-thumbs .swiper-slide').outerWidth();
    $('.gallery-thumbs').css('height', productCarouselThumbsItemWith);

    /////////////////
    $('.video_slider').css({ display: 'block' });

    //Script to open / close modals in footer
    var Navs_Open = function (options) {
        var vars = {
            element: 'original Value',
            elementsToEdit: [],
            timing: true
        };

        var root = this;

        this.construct = function (options) {
            $.extend(vars, options);
        };

        this.myPublicMethod = function () {
            $(vars.element)
                .find('h3')
                .click(function () {
                    myPrivateMethod();
                });
        };

        var myPrivateMethod = function () {
            if (vars.timing == true) {
                TimingBetweenOperations();
                for (var i = 0; i < vars.elementsToEdit.length; i++) {
                    $(vars.element).find(vars.elementsToEdit[i]).slideToggle();
                }
            }
        };

        var TimingBetweenOperations = function () {
            vars.timing = false;
            setTimeout(function () {
                vars.timing = true;
            }, 500);
        };

        this.construct(options);
    };

    var followUS = new Navs_Open({
        element: '#follow_us_id',
        elementsToEdit: ['p']
    });
    var newShelter = new Navs_Open({
        element: '#newshelter_id',
        elementsToEdit: ['p', 'form']
    });
    followUS.myPublicMethod();
    newShelter.myPublicMethod();

    //------------------------------Load Vimeo Videos----------------------//

    var VimeoVID = function (options) {
        var vars = {
            videoID: 0,
            videoName: 0,
            elementToCreate: '',
            api: 1,
            color: '392F5A',
            title: 0,
            badge: 0,
            byline: 0,
            portrait: 0,
            autoplay: 0,
            apiSRC: ''
        };
        var root = this;

        this.construct = function (options) {
            $.extend(vars, options);
        };

        this.start = function () {
            createSRC();
            createObject();
        };
        var createObject = function () {
            $(vars.elementToCreate).append(
                '<iframe class="video" id="video_1" rel="preload" height="500" src="' +
                    vars.apiSRC +
                    '" frameborder="0" webkitallowfullscreen="true" allowfullscreen="true" style="height: 500px;"></iframe>'
            );
        };

        var createSRC = function () {
            vars.apiSRC =
                '//player.vimeo.com/video/' +
                vars.videoID +
                '?api=' +
                vars.api +
                '&player_id=' +
                vars.videoName +
                '&color=' +
                vars.color +
                '&title=' +
                vars.title +
                '&badge=' +
                vars.badge +
                '&byline=' +
                vars.byline +
                '&portrait=' +
                vars.portrait +
                '&autoplay=' +
                vars.autoplay;
        };
        this.construct(options);
    };
    var apended = false;
    var allElements;

    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        if (scroll > $('#great_reactions').scrollTop() && apended == false) {
            MagicScroll.refresh('magic_scroll_vimeo');
            apended = true;
            var vimeo_1 = new VimeoVID({
                videoID: '472326641',
                videoName: 'video_1',
                elementToCreate: '#video1_id'
            });
            vimeo_1.start();
            var vimeo_2 = new VimeoVID({
                videoID: '472270235',
                videoName: 'video_2',
                elementToCreate: '#video2_id'
            });
            vimeo_2.start();
            var vimeo_3 = new VimeoVID({
                videoID: '472326701',
                videoName: 'video_2',
                elementToCreate: '#video3_id'
            });
            vimeo_3.start();
            var vimeo_4 = new VimeoVID({
                videoID: '472326851',
                videoName: 'video_2',
                elementToCreate: '#video4_id'
            });
            vimeo_4.start();
            var vimeo_5 = new VimeoVID({
                videoID: '472324599',
                videoName: 'video_2',
                elementToCreate: '#video5_id'
            });
            vimeo_5.start();
            var vimeo_6 = new VimeoVID({
                videoID: '472286398',
                videoName: 'video_2',
                elementToCreate: '#video6_id'
            });
            vimeo_6.start();
            /* setTimeout(function () {
                $('.mcs-button').click(function () {
                    $('.video_slider')
                        .find('.video')
                        .each(function () {
                            var player = new Player($(this));
                            player.pause();
                        });
                });
            }, 1000); */

            MagicScroll.refresh();
            // MagicScroll.start('magic_scroll_vimeo');
            setHeightForProducts();
        }
    });

    $(window).resize(function () {
        setHeightForProducts();
    });

    //Update product price and ATC note function

    const displayVariantNote = (activeEl) => {
        const variantNote = document.querySelector('.canvas-list__note');
        if (!variantNote) return;
        const digitalText = variantNote.querySelector('#digital-note');
        const canvasText = variantNote.querySelector('#canvas-note');

        variantNote.dataset.activeVariant = activeEl.dataset.variantIndex;

        const isDigitalFileSelected = activeEl
            .querySelector('.canvas-list__item-title')
            .classList.contains('canvas-list__item-title--digital-file');

        if (isDigitalFileSelected) {
            digitalText.style.display = 'block';
            canvasText.style.display = 'none';
        } else {
            digitalText.style.display = 'none';
            canvasText.style.display = 'block';
        }
    };

    //SELECT in product
    $('.select_block')
        .find('li')
        .click(function () {
            $('.select_block').find('li').removeClass('active');
            $(this).addClass('active');
            $('.text_block').removeClass('active');
            $('.' + $(this).attr('id')).addClass('active');
        });
    $('.one_option_selection')
        .find('li')
        .click(function () {
            $('.one_option_selection').find('li').removeClass('selected');
            $(this).addClass('selected');
            $('.input_variant').val($(this).attr('id'));
            var price = $(this).attr('data-value');
            var old_price = $(this).attr('data');

            $('.shop_button_add_to_cart').find('.current_price').html(price);
            $('.price').find('.money').html(price);
            const price_only_numbers = price.replace(/\D/g, '');
            const old_price_only_numbers = old_price.replace(/\D/g, '');
            var discount = Math.floor(100 - (price_only_numbers / old_price_only_numbers) * 100);

            //console.log(discount);
            $('.discount_percent').html(discount + '%');
            $('.old_price').html(old_price);

            //bad naming -> just for more obvious type change
            const myPrice = parseInt(price_only_numbers);
            const myOldPrice = parseInt(old_price_only_numbers);

            updateProductPrice(myPrice, myOldPrice);

            displayVariantNote(this);
        });

    //------------------------------------------
});

const updateProductPrice = (price, compareAtPrice) => {
    const originalPriceElement = document.querySelector('.single-product__sale-price .sale-price__original');
    const salePriceElement = document.querySelector('.single-product__sale-price .sale-price__sale');
    const savePriceElement = document.querySelector('.single-product__sale-price .sale-price__save');

    const saveNoteElement = document.querySelector('.sale-note__save');

    //Select standard ATC + clonned ones by uploadcare?
    const atcPrices = document.querySelectorAll('.current_price');

    const isGlobalDiscountActive = window.theme.globalDiscount;

    const formatPrice = (number, decimals = 2) => {
        const roundedNumber = Math.ceil(number) / 100;
        const currency = window.Shopify.currency.active;
        const showCurrencies = ['CAD', 'AUD'];

        const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        })
            .format(roundedNumber)
            .replace('CA$', '$')
            .replace('A$', '$')
            .trim();

        if (showCurrencies.includes(currency)) {
            return `${currency} ${formattedPrice}`;
        }

        return formattedPrice;
    };

    let originalPrice = compareAtPrice;
    let salePrice = price;

    /* if (isGlobalDiscountActive) {
        originalPrice = price;
        salePrice = originalPrice * window.theme.discountPriceMultiplier;
    } */

    if (window.theme?.priceAddition > 0) {
        originalPrice = originalPrice + window.theme.priceAddition;
        salePrice = salePrice + window.theme.priceAddition;
    }

    const savePrice = Math.round((originalPrice - salePrice) / 100) * 100;

    const formattedOriginalPrice = formatPrice(originalPrice, 0);
    const formattedSalePrice = formatPrice(salePrice);
    const formattedSavePrice = formatPrice(savePrice, 0);

    console.debug('updateProductPrice', {
        salePrice,
        originalPrice,
        savePrice,
        formattedOriginalPrice,
        formattedSalePrice,
        formattedSavePrice
    });

    originalPriceElement.textContent = formattedOriginalPrice;
    salePriceElement.textContent = `${formattedSalePrice} Sale`;
    savePriceElement.textContent = `Save ${formattedSavePrice}`;

    if (isGlobalDiscountActive) {
        saveNoteElement.textContent = `Save ${formattedSavePrice}`;
    }

    atcPrices.forEach((priceEl) => {
        priceEl.textContent = `${formatPrice(salePrice)}`;
    });
};

function setHeightForProducts() {
    var height_of_product_img = $('.product').find('.image_place').find('img').height();
    if (height_of_product_img < 1) {
        $('.product').find('.image_place').css({ height: 'auto' });
    } else {
        setTimeout(function () {
            height_of_product_img = $('.product').find('.image_place').find('img').height();
            $('.product')
                .find('.image_place')
                .css({ height: height_of_product_img + 'px' });
        }, 100);
    }
}
$(window).on('load', function () {
    $('.have_more_elements').click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }
    });

    setHeightForProducts();
});

window.UploadKit = window.UploadKit || {};
window.UploadKit.cloneATCButton = true;
